var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 257,
    viewBox: "0 0 173 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1669",
    x: 33.0664,
    y: 68.25,
    width: 129.5,
    fill: "none",
    height: 39.5,
    rx: 19.75,
    stroke: "#112034",
    strokeWidth: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1670",
    x: 70.3164,
    y: 166.5,
    width: 100,
    fill: "none",
    height: 65,
    rx: 8,
    stroke: "#112034",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 256",
    cx: 37.8164,
    cy: 156,
    r: 3,
    fill: "#112034"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 56.8164,
    cy: 156,
    r: 3,
    fill: "#112034"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 258",
    cx: 75.8164,
    cy: 156,
    r: 3,
    fill: "#112034"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 259",
    cx: 37.8164,
    cy: 179,
    r: 3,
    fill: "#112034"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 260",
    cx: 56.8164,
    cy: 179,
    r: 3,
    fill: "#112034"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 261",
    cx: 37.8164,
    cy: 202,
    r: 3,
    fill: "#112034"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 262",
    cx: 56.8164,
    cy: 202,
    r: 3,
    fill: "#112034"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M126.622 194.819C126.364 195.413 126.151 196.014 125.983 196.621C125.815 197.228 125.731 197.854 125.731 198.5C125.731 199.146 125.809 199.779 125.964 200.399C126.119 201.019 126.351 201.613 126.661 202.181L128.831 201.406C128.547 200.967 128.347 200.502 128.231 200.011C128.114 199.52 128.056 199.017 128.056 198.5C128.056 197.983 128.127 197.48 128.269 196.989C128.411 196.498 128.599 196.02 128.831 195.555L126.622 194.819ZM121.352 192.61C120.939 193.54 120.642 194.502 120.461 195.497C120.28 196.491 120.19 197.493 120.19 198.5C120.19 199.508 120.28 200.502 120.461 201.484C120.642 202.465 120.939 203.421 121.353 204.351L123.561 203.576C123.174 202.775 122.902 201.949 122.747 201.096C122.592 200.244 122.515 199.378 122.515 198.5C122.515 197.622 122.599 196.75 122.767 195.884C122.935 195.019 123.2 194.186 123.561 193.385L121.352 192.61ZM116.276 190.44C115.708 191.732 115.295 193.049 115.036 194.393C114.778 195.736 114.649 197.105 114.649 198.5C114.649 199.895 114.778 201.264 115.036 202.608C115.295 203.951 115.708 205.255 116.276 206.521L118.446 205.669C117.93 204.532 117.555 203.363 117.322 202.162C117.09 200.961 116.974 199.74 116.974 198.5C116.974 197.26 117.09 196.033 117.322 194.819C117.555 193.605 117.93 192.429 118.446 191.293L116.276 190.44ZM120.5 183C122.618 183 124.62 183.407 126.506 184.221C128.392 185.034 130.039 186.145 131.447 187.553C132.855 188.961 133.966 190.608 134.779 192.494C135.593 194.38 136 196.382 136 198.5C136 200.644 135.593 202.659 134.779 204.545C133.966 206.431 132.855 208.071 131.447 209.466C130.039 210.861 128.392 211.966 126.506 212.779C124.62 213.593 122.618 214 120.5 214C118.356 214 116.341 213.593 114.455 212.779C112.569 211.966 110.929 210.861 109.534 209.466C108.139 208.071 107.034 206.431 106.221 204.545C105.407 202.659 105 200.644 105 198.5C105 196.382 105.407 194.38 106.221 192.494C107.034 190.608 108.139 188.961 109.534 187.553C110.929 186.145 112.569 185.034 114.455 184.221C116.341 183.407 118.356 183 120.5 183ZM120.5 185.325C116.832 185.325 113.719 186.61 111.161 189.181C108.604 191.751 107.325 194.858 107.325 198.5C107.325 202.168 108.604 205.281 111.161 207.839C113.719 210.396 116.832 211.675 120.5 211.675C124.142 211.675 127.249 210.396 129.819 207.839C132.39 205.281 133.675 202.168 133.675 198.5C133.675 194.857 132.39 191.751 129.819 189.181C127.249 186.61 124.142 185.325 120.5 185.325Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5351 15.5H25C19.7533 15.5 15.5 19.7533 15.5 25V231.768C15.5 237.014 19.7533 241.268 25 241.268H82.5351C87.5046 241.268 91.5829 237.452 92 232.59V233H107.505C106.863 246.235 95.929 256.768 82.5351 256.768H25C11.1929 256.768 0 245.575 0 231.768V25C0 11.1929 11.1929 0 25 0H82.5351C96.3423 0 107.535 11.1929 107.535 25V75H92.0351V25C92.0351 19.7533 87.7818 15.5 82.5351 15.5ZM107.535 165V101H92.0351V165H107.535Z",
    fill: "#112034"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartLockIcon);
export default __webpack_public_path__ + "static/media/SmartLock_Icon.a9b7c71ae33a1456b5cd60112a8a6003.svg";
export { ForwardRef as ReactComponent };